import React from 'react';
import { motion } from 'framer-motion';
import { ScaleIcon, XIcon } from 'lucide-react';
import { costs } from '../data/problems';
export function CostSection() {
  return <section className="bg-petrol py-16 sm:py-20" aria-labelledby="cost-title" data-id="element-49" data-mp="4l7ys24ll3kh">
      <div className="mx-auto max-w-4xl px-4" data-id="element-50" data-mp="4j52j0cuqe7b">
        <div className="text-center" data-id="element-51" data-mp="3vsapksgix7u6">
          <ScaleIcon className="mx-auto h-9 w-9 text-aqua" data-id="element-52" data-mp="3vr94dv5sn4yq" />
          <h2 id="cost-title" className="mt-4 text-3xl font-extrabold text-white sm:text-4xl" data-id="element-53" data-mp="3qsoasel1rjj9">El costo de no tenerlo</h2>
          <p className="mt-3 text-mutedDark" data-id="element-54" data-mp="3mp9kmv3e9ms3">Lo que realmente perdés cada ciclo lectivo sin el Megapack</p>
        </div>

        <div className="mt-10 space-y-2" data-id="element-55" data-mp="3htu949sv02yu">
          {costs.map(([without, loss], index) => <motion.div key={without} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: index * 0.04
        }} className="grid gap-2 rounded-xl border border-lineDark bg-petrolDark p-4 sm:grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)] sm:gap-6" data-id="element-56" data-mp="3cureljai9f54" data-mpi={index}>
              <p className="flex items-start gap-2 text-sm font-bold text-white" data-id="element-57" data-mp="t6ty7dplwx7t">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#F0A9A3]" data-id="element-58" data-mp="fb8araz0ulhi" />
                {without}
              </p>
              <p className="text-sm leading-relaxed text-mutedDark" data-id="element-59" data-mp="kabgkxmtsvqj">{loss}</p>
            </motion.div>)}
        </div>

        <blockquote className="mt-10 rounded-2xl border border-aqua/35 bg-petrolDark p-6 text-center text-sm font-semibold leading-relaxed text-onDark sm:p-8" data-id="element-60" data-mp="1cxnsmdvd1l5l">
          “La próxima vez que un alumno pregunte para qué sirve estudiar Instrumentación Quirúrgica, podés mostrarle que Argentina
          tiene programas de trasplante de clase mundial, que el Checklist OMS que usan los mejores hospitales del planeta fue
          adaptado para nuestros quirófanos por resolución ministerial, y que cada protocolo que parece burocrático existe porque
          alguna vez alguien murió por no tenerlo. O podés seguir explicando sin ese contexto.”
        </blockquote>
      </div>
    </section>;
}